import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLang } from '@src/utils/util.js'

Vue.use(VueI18n)

// Register I18N instance and introduce language file, file format, etc.
const languages = ['en-US', 'zh-CN', 'vi-VN', 'th-TH', 'ms-MY', 'id-ID', 'hi-IN', 'fil-PH', 'zh-TW']
const loadedLanguages = []
let lang = getLang()
function getCurrentLang(lang) {
  if (languages.includes(lang)) {
    return lang
  }
  for (let i = 0; i < languages.length; i++) {
    let langArr = lang.split('-')
    let currentLangArr = languages[i].split('-')
    if (langArr[0] == currentLangArr[0] && langArr[1] == currentLangArr[1]) {
      return languages[i]
    } else if (langArr[0] == currentLangArr[0] || langArr[1] == currentLangArr[1]) {
      return languages[i]
    }
  }
  return 'en-US'
}
let currentLang = getCurrentLang(lang)
const i18n = new VueI18n({
  locale: currentLang,
  messages: ''
})
export function loadLanguageAsync() {
  if (loadedLanguages.includes(currentLang)) {
    return Promise.resolve()
  }
  return import(`./${currentLang}/base.json`).then(msgs => {
    loadedLanguages.push(currentLang)
    i18n.setLocaleMessage(currentLang, msgs)
    i18n.locale = currentLang
  })
}

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js